// extracted by mini-css-extract-plugin
module.exports = {"root":"text_root__MRqeZ"};